import common from "./common";
import login from "./login";
import dashboard from "./dashboard";
import optimize from "./optimize";
import message from "./message";
import feedback from "./feedback";
import settings from "./settings";
import survey from "./survey";
import userguide from "./userguide";
import footer from "./footer";

import plan from "./plan";
import storage_addon from "./storage_addon";
import intro from "./intro";

const mergeTranslations = (...modules) => {
  const result = {};
  modules.forEach(module => {
    Object.keys(module).forEach(lang => {
      result[lang] = { ...(result[lang] || {}), ...module[lang] };
    });
  });
  return result;
};

const translations = mergeTranslations(common, login, dashboard, optimize, message, feedback, settings, survey, userguide, plan, footer, storage_addon, intro);

export default translations;
